import { ContentItem, Elements } from '@kentico/kontent-delivery';

/**
 * Generated by Raaz Khoshnood Manually
 * Tip: You can replace 'ContentItem' with another generated class to fully leverage strong typing.
 */
export class FundVideo extends ContentItem {
  public videoId: Elements.TextElement;
  constructor() {
    super({
      propertyResolver: (elementName: string) => {
        if (elementName === 'video_id') {
          return 'videoId';
        }
        return elementName;
      },
    });
  }
}
